import { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { FALLBACK_IMAGE } from "../productService";

const ProductGallery = ({ images = [], name }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const galleryImages = useMemo(() => {
    if (Array.isArray(images) && images.length > 0) {
      return images;
    }
    return [FALLBACK_IMAGE];
  }, [images]);

  useEffect(() => {
    setCurrentImageIndex(0);
  }, [galleryImages]);

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
  };
  
  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? galleryImages.length - 1 : prevIndex - 1
    );
  };
  
  return (
    <div className="relative">
      <div className="relative overflow-hidden rounded-lg aspect-[3/4]">
        <img
          src={galleryImages[currentImageIndex]}
          alt={name}
          className="object-contain w-full h-full"
        />
 
        {galleryImages.length > 1 && (
          <>
            <button 
              onClick={prevImage}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white/80 rounded-full p-1"
              aria-label="Previous image"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>
            
            <button 
              onClick={nextImage}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white/80 rounded-full p-1"
              aria-label="Next image"
            >
              <ChevronRight className="h-6 w-6" />
            </button>
          </>
        )}
      </div>
      
      {galleryImages.length > 1 && (
        <div className="flex mt-4 space-x-2 justify-center">
          {galleryImages.map((thumbnail, index) => (
            <button 
              key={index} 
              onClick={() => setCurrentImageIndex(index)}
              className={`relative w-16 h-20 border-2 ${
                currentImageIndex === index ? "border-black" : "border-transparent"
              }`}
            >
              <img
                src={thumbnail}
                alt={`Thumbnail ${index + 1}`}
                className="object-contain w-full h-full"
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductGallery;